// Node modules
import { Container, SpineBase, delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import {
  BigWinController,
  SlotEventConstantsBehavior,
  SlotConstantsBehavior,
  MeterBehavior,
  Model,
  SoundConstant,
} from "@quest/murka-games-behavior-panther/dist";
import { Linear } from "@quest/pixi-bridge/dist/easing/Easing";
import { Emitter } from "@quest/pixi-bridge/dist/Particles/Emitter";

// Game modules
import { BigWinViewGame } from "./BigWinViewGame";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants, spineConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class BigWinControllerGame extends BigWinController {
  private bigWinBackground: SpineBase;
  protected view: BigWinViewGame;
  private bigWinBGContainer: Container;
  private bigWinCharContainer: Container;
  private bigWinBackgroundPortrait: SpineBase;
  private bigWinCharContainerPortrait:Container;
  private bigWinBGContainerPortrait:Container;
  private tickupAmountLevel: number;
  private coinShowerContainerMask: any;
  private emitter: Emitter;
  private emitterPortrait: Emitter;
  private hideBigWinDelay: number = 700;

  /**
   * Method overrided to add game end methods.
   * @param view
   * @param model
   */
  constructor(view: BigWinViewGame, model: Model) {
    super(view, model);
    this.showBigWinMask();
  }

  /**
   * Overrided to add bigwin spine parts
   */
  public initializeBigWin(): void {
    this.bigWinMeter = this.view.getMeterById("bigWinMtr") as MeterBehavior;
    this.bigWinContainer = this.view.getContainerByID("bigWinContainer");
    this.bigWinMainContainer = this.view.getContainerByID("bigWinMainContainer");
    this.bigWinMeterContainer = this.view.getContainerByID("bigWinMeterContainer");
    this.bgSpineContainer = this.view.getContainerByID("backgroundSpineContainer");
  
      //commented to run game in landscape
      !ingenuity.deviceEnv.isDesktop && this.initializePortraitComponent();
    this.bigWinBGContainer = this.view.getContainerByID("bigWinBGContainer");
    this.bigWinCharContainer = this.view.getContainerByID("bigWinCharContainer");
    this.bigWinBackground = this.view.createBigWinSpine("Bigwin_spine");
    this.bigWinBGContainer.addChild(this.bigWinBackground);
    this.bgLoopSpine = this.view.createBigWinSpine("Bigwin_spine");
    this.bigWinCharContainer.addChildAt(this.bgLoopSpine, 0);
    this.coinShowerContainerMask = this.view.getShapeById("coinShowerContainerMask") as any;
    this.coinShowerContainerMask.y = this.view.json.Y_POSITION[0];
    if (!ingenuity.deviceEnv.isDesktop) {
      this.coinShowerContainerMask.y = this.view.json.Y_POSITION[1];
    }
  }


  /**
   * Method to show big win mask
   */
  private showBigWinMask(): void {
    this.bigWinCharContainer.mask = this.view.getShapeById("winMask");
  }

  subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(SlotEventConstantsBehavior.SHOW_BIG_WIN, this.startBigWin, this);
    dispatcher.on(SlotEventConstants.SUMUP_BIGWIN, this.onSumpBigWin, this);
    //dispatcher.on(SlotEventConstantsBehavior.SUMUP_BIGWIN_FG, this.stopBigWinAndTicker, this);
  }

  unSubscribeEvents(): void {
    dispatcher.off(SlotEventConstantsBehavior.SHOW_BIG_WIN, this.startBigWin);
    dispatcher.off(SlotEventConstants.SUMUP_BIGWIN, this.onSumpBigWin, this);
    dispatcher.off(SlotEventConstantsBehavior.SUMUP_BIGWIN_FG, this.stopBigWinAndTicker, this);
  }

  // Overrided to initialize portarit elements
  protected initializePortraitComponent(): void {
     this.bigWinBGContainerPortrait = this.view.getContainerByID("bigWinBGPortraitContainer");
    this.bigWinCharContainerPortrait = this.view.getContainerByID("bigWinCharPortraitContainer");
    this.bgLoopPortraitSpine = this.view.createBigWinSpine("Bigwin_spine");
    this.bigWinCharContainerPortrait.addChild(this.bgLoopPortraitSpine);
    this.bigWinBackgroundPortrait = this.view.createBigWinSpine("Bigwin_spine");
    this.bigWinBGContainerPortrait.addChild(this.bigWinBackgroundPortrait);
  }

  // Overrided to hide free spin counter meter & stop base game sound
  protected startBigWin(): void {
    ingenuity.configData.showLogoBaseGameScreen = false;
    this.playBigWinStartSound();
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BOTTOM_BAR_ON_TOP, this);
    this.bringBigWinBelowButtonPanel();
    this.playBgSpineInLoop();
    this.showBigWinMeterWithZoomIn();
    this.addButtonPanelOnTop();
    this.stopBaseGameSounds();
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO);
  }
      dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_BIG_WIN_BLUR_BG);

  }


  private playBigWinStartSound(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstantGame.BIG_WIN_SLOT,
      vol: 1,
      loop: false,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
  }


  // fucnction to start big win feature
  private startBigWinState(): void {
    this.tickupAmountLevel = this.model.getIsBigWin();
    this.currentWinAmountTickUp = (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as GameParserModel).getclueRevealedWinAmt();
  }

  /**
   * function to add button panel on top
   */
  protected playBgSpineInLoop(): void {
    this.playDesktopSpine();
    !ingenuity.deviceEnv.isDesktop && this.playPortraitSpine();
  }

  private addButtonPanelOnTop(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    }
  }

  /**overrided to stat tick up meter  according to tick up level*/
  protected showBigWinMeterBasedOnState(): void {
    this.bigWinMeter.visible = true;
    if (this.tickupAmountLevel === 1) {
      this.startBigWinTickup();
    } else {
      const tickupAmount = (gameConstants.SUPER_WIN_MULTIPLIER * this.model.getTotalBet());
      this.bigWinMeter.startTick((tickupAmount-2),true,false,this.model.getWinMeterTickUpDuration(tickupAmount),true,this.superWinState.bind(this)
    );
    }
  }

  /**
   * Add to start big win tickup
   */
  protected startBigWinTickup(): void {
    this.bigWinMeter.startTick(
      this.currentWinAmountTickUp,
      true,
      false,
      this.model.getWinMeterTickUpDuration(this.currentWinAmountTickUp),
      true,
      this.bigWinPresentationComplete.bind(this)
    );
  }

  private enableStageClick(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ENABLE_STAGE_CLICK);
      ingenuity.configData.enableStageClick = true;
    } 
    else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ENABLE_STAGE_CLICK_FG);
      this.currentWinAmountTickUp = (ingenuity.parserModel as GameParserModel).getTotalFgCascadeWin();
    }
  }

  // function to start coin shower in super big win and sum up count till super win
  private superWinState(): void {
        dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_SUPER_WIN_BLUR_BG);
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstantGame.INTRO_SUPER_WIN,
      vol: 1,
      loop: false,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });

    this.playSuperWinSpine();
    !ingenuity.deviceEnv.isDesktop && this.playPortraitSuperWinSpine();
    
    this.playCoinShower();
    if (this.tickupAmountLevel === 2) {
      this.startBigWinTickup();
    } else {
      const tickupAmount = (gameConstants.EPIC_WIN_MULTIPLIER * this.model.getTotalBet());
      this.bigWinMeter.startTick(
        (tickupAmount-4),
        true,
        false,
        this.model.getWinMeterTickUpDuration(tickupAmount),
        true,
        this.epicWinState.bind(this)
      );
    }
  }

  private playPortraitSuperWinSpine():void{
    this.bgLoopPortraitSpine.onComplete.dispose();
    this.bigWinBackgroundPortrait.onComplete.dispose();
    this.bgLoopPortraitSpine.playAnim("big_win_to_super_win_portrait_fg", false);
    this.bigWinBackgroundPortrait.playAnim("big_win_to_super_win_portrait_bg", false);
    this.bgLoopPortraitSpine.onComplete.addOnce(() => {
      this.bgLoopPortraitSpine.playAnim("super_win_loop_portrait_fg", true);
      this.bigWinBackgroundPortrait.playAnim("super_win_loop_portrait_bg", true);
    }, this);
  }

  private epicWinState(): void {
        dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_EPIC_WIN_BLUR_BG);
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstantGame.INTRO_EPIC_WIN,
      vol: 1,
      loop: false,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });

    this.playEpicWinSpine();
    !ingenuity.deviceEnv.isDesktop && this.playPortraitEpicWinSpine();

    if (this.tickupAmountLevel === 3) {
      this.startBigWinTickup();
    } else {
      const tickupAmount =( gameConstants.CRAZY_WIN_MULTIPLIER * this.model.getTotalBet());
      this.bigWinMeter.startTick(
        (tickupAmount-6),
        true,
        false,
        this.model.getWinMeterTickUpDuration(tickupAmount),
        true,
        this.crazyWinState.bind(this)
      );
    }
  }

  private playPortraitEpicWinSpine():void{
    this.bgLoopPortraitSpine.onComplete.dispose();
    this.bigWinBackgroundPortrait.onComplete.dispose();
    this.bgLoopPortraitSpine.playAnim("super_win_to_epic_win_portrait_fg", false);
    this.bigWinBackgroundPortrait.playAnim("super_win_to_epic_win_portrait_bg", false);
    this.bgLoopPortraitSpine.onComplete.addOnce(() => {
      this.bgLoopPortraitSpine.playAnim("epic_win_loop_portrait_fg", true);
      this.bigWinBackgroundPortrait.playAnim("epic_win_loop_portrait_bg", true);
    }, this);
  }
  /**
   * Overrided to play bigwin spine in parts
   */
  protected playDesktopSpine(): void {
    this.bgLoopSpine.visible = true;
    this.bigWinBackground.visible = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {id: SoundConstant.BIG_WIN_START,vol: 1,loop: false,key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,});
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {id: SoundConstant.BIG_WIN_LOOP,vol: 1,loop: true,key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,});
    this.bgLoopSpine.onComplete.dispose();
    this.bigWinBackground.onComplete.dispose();
    this.bgLoopSpine.playAnim(spineConstants.BIGWIN_IN_ANIM, false);
    this.bigWinBackground.playAnim(spineConstants.BIGWIN_BACKGROUND_IN_ANIM, false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.bgLoopSpine.playAnim(spineConstants.BIGWIN_LOOP_ANIM, true);
      this.bigWinBackground.playAnim(spineConstants.BIGWIN_BACKGROUND_LOOP_ANIM, true);
    }, this);
  }

  // function to play spine of super win
  private playSuperWinSpine(): void {
    this.bgLoopSpine.onComplete.dispose();
    this.bigWinBackground.onComplete.dispose();
    this.bgLoopSpine.playAnim(spineConstants.BIGWIN_TO_SUPERWIN_ANIM, false);
    this.bigWinBackground.playAnim(spineConstants.BIGWIN_TO_SUPERWIN_BACKGROUND_ANIM, false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.bgLoopSpine.playAnim(spineConstants.SUPERWIN_LOOP_ANIM, true);
      this.bigWinBackground.playAnim(spineConstants.SUPERWIN_BACKGROUND_LOOP_ANIM, true);
    }, this);
  }

  // function to play spine of epic win
  private playEpicWinSpine(): void {
    this.bgLoopSpine.onComplete.dispose();
    this.bigWinBackground.onComplete.dispose();

    this.bgLoopSpine.playAnim(spineConstants.SUPER_TO_EPIC_WIN_ANIM, false);
    this.bigWinBackground.playAnim(spineConstants.SUPER_TO_EPIC_WIN_BACKGROUND_ANIM, false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.bgLoopSpine.playAnim(spineConstants.EPICWIN_LOOP_ANIM, true);
      this.bigWinBackground.playAnim(spineConstants.EPICWIN_BACKGROUND_LOOP_ANIM, true);
    }, this);
  }

  private crazyWinState(): void {
        dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_CRAZY_WIN_BLUR_BG);
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
      id: SoundConstantGame.INTRO_CRAZY_WIN,
      vol: 1,
      loop: false,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });
    
    this.playCrazyWinSpine();
    !ingenuity.deviceEnv.isDesktop && this.playPortraitCrazyWinSpine();

    this.startBigWinTickup();
  }


  // function to play spine of crazy win
  private playPortraitCrazyWinSpine(): void {
    this.bigWinBackgroundPortrait.onComplete.dispose();
    this.bgLoopPortraitSpine.onComplete.dispose();
    this.bgLoopPortraitSpine.playAnim("epic_win_to_crazy_win_portrait_fg", false);
    this.bigWinBackgroundPortrait.playAnim("epic_win_to_crazy_win_portrait_bg", false);
    this.bgLoopPortraitSpine.onComplete.addOnce(() => {
      this.bgLoopPortraitSpine.playAnim("crazy_win_loop_portrait_fg", true);
      this.bigWinBackgroundPortrait.playAnim("crazy_win_loop_portrait_bg", true);
    }, this);
  }

  // function to play spine of crazy win
  private playCrazyWinSpine(): void {
    this.bgLoopSpine.onComplete.dispose();
    this.bigWinBackground.onComplete.dispose();

    this.bgLoopSpine.playAnim(spineConstants.EPIC_TO_CRAZY_WIN_ANIM, false);
    this.bigWinBackground.playAnim(spineConstants.EPIC_TO_CRAZY_WIN_BACKGROUND_ANIM, false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.bgLoopSpine.playAnim(spineConstants.CRAZYWIN_LOOP_ANIM, true);
      this.bigWinBackground.playAnim(spineConstants.CRAZYWIN_BACKGROUND_LOOP_ANIM, true);
    }, this);
  }

  // Overrided to play portrait spine
  protected playPortraitSpine(): void {
    this.bigWinBackgroundPortrait.visible = true;
    this.bigWinBackgroundPortrait.playAnim("big_win_portrait_in_bg", false);
    this.bgLoopPortraitSpine.visible = true;
    this.bgLoopPortraitSpine.playAnim("big_win_portrait_in_fg", false);
    this.bigWinBackgroundPortrait.onComplete.addOnce(() => {
      this.bigWinBackgroundPortrait.playAnim("big_win_portrait_loop_bg", true);
      this.bgLoopPortraitSpine.playAnim("big_win_portrait_loop_fg", true);
    }, this);
  }

  // Overrided to stop big win bgm sound
  protected bigWinPresentationComplete() {
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, {
      id: SoundConstant.BIG_WIN_LOOP,
      key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
    });

    delayedCall(
      SlotConstantsBehavior.FADE_OUT_BIG_WIN_DELAY,
      this.hideBigWinDelay,
      () => {
        killDelayedCall(SlotConstantsBehavior.FADE_OUT_BIG_WIN_DELAY);
        this.hideBigWin();
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
        dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_WIN_METER_BEFORE_CLOSE_IN_BIGWIN, { value: this.currentWinAmountTickUp });
        dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_FREE_GAME_WIN_METER_AFTER_BIGWIN, this.currentWinAmountTickUp);
      },
      this
    );
  }

  // Overridden method to handle big win hiding with animations
  protected hideBigWin() {
    this.playWinOutDesktopSpine();
    this.bigWinBackground.onComplete.addOnce(() => {
      this.hideBigWinWithFadeOutEffect();
      this.hideBigWinBasedOnState();
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO);
      }
    }, this);
  }

  private desabledStageClick(): void {
    ingenuity.configData.enableStageClick = false;
    dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
  }

  private playWinOutDesktopSpine(): void {
    this.bgLoopSpine.onComplete.dispose();
    this.bigWinBackground.onComplete.dispose();
    if (this.tickupAmountLevel === 1) {
      this.bgLoopSpine.playAnim(spineConstants.BIGWIN_OUT_ANIM, false);
      this.bigWinBackground.playAnim(spineConstants.BIGWIN_BACKGROUND_OUT_ANIM, false);
    } else if (this.tickupAmountLevel === 2) {
      this.bgLoopSpine.playAnim(spineConstants.SUPERWIN_OUT_ANIM, false);
      this.bigWinBackground.playAnim(spineConstants.SUPERWIN_BACKGROUND_OUT_ANIM, false);
    } else if (this.tickupAmountLevel === 3) {
      this.bgLoopSpine.playAnim(spineConstants.EPICWIN_OUT_ANIM, false);
      this.bigWinBackground.playAnim(spineConstants.EPICWIN_BACKGROUND_OUT_ANIM, false);
    } else {
      this.bgLoopSpine.playAnim(spineConstants.CRAZYWIN_OUT_ANIM, false);
      this.bigWinBackground.playAnim(spineConstants.CRAZYWIN_BACKGROUND_OUT_ANIM, false);
    }
  }

  // Add to play coin shower
  private playCoinShower(): void {
    this.initializeCoinShowerEmitter();
    this.startCoinShowerEmitter();
    if (!ingenuity.deviceEnv.isDesktop) {
      this.initPortraitCoinShowerEmitter();
      this.startPortraitShowerEmitter();
    }
  }

  // Override to unfade 2nd free game bgm
  protected hideBigWinBasedOnState(): void {
    dispatcher.fireEvent(eventDispatchers.HIDE_POP_UP_BLUR_BG);
    this.bigWinMeterContainer.visible = false;
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.FADE_OUT_SOUND, {
        id: SoundConstant.BASEGAME_BGMLOOP,
        vol: 1,
        key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
      });
      this.model.setIsBigWinRunning(false);
      this.fadeInBaseGameSound();
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_AFTER_BIGWIN);
      !(ingenuity.parserModel as GameParserModel).getMoneyHuntingFetureStatus() && dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    } else {
      ingenuity.currentGame.state.getCurrentState().model.setIsBigWinRunning(false);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_FREE_GAME_AFTER_BIGWIN);
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOTAL_WIN_MSG);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_FREESPIN_COUNTER);
    }
  }

  /**
   * Initialize Data for Coin Shower Emmiter
   */
  private initializeCoinShowerEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 0.8,
        end: 1,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 500,
        end: 500,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 200,
      },
      maxSpeed: 0,
      startRotation: {
        min: -140,
        max: -50,
      },
      noRotation: true,
      rotationSpeed: {
        min: 0,
        max: 0,
      },
      lifetime: {
        min: 3,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.05,
      emitterLifetime: -1,
      maxParticles: 150,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("coinShowerContainer");
    coinShowerContainer && (coinShowerContainer.mask = this.coinShowerContainerMask);
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as Emitter;
  }

  // Add to initialize portrait coin shower emitter
  private initPortraitCoinShowerEmitter(): void {
    const particleData1: any = {
      emitterType: 1,
      id: "winCoinEmitterPortrait",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config1 = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 0.9,
        end: 1,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 500,
        end: 500,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 160,
      },
      maxSpeed: 0,
      startRotation: {
        min: -140,
        max: -50,
      },
      noRotation: true,
      rotationSpeed: {
        min: 0,
        max: 0,
      },
      lifetime: {
        min: 3,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.05,
      emitterLifetime: -1,
      maxParticles: 150,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("coinShowerPortraitContainer");
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData1, config1) as Emitter;
  }

  /**
   * Method to start the emitter
   * @returns
   */
  private startCoinShowerEmitter(): void {
    this.emitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter");
    this.emitter.autoUpdate = true;
    this.emitter.emit = true;
  }

  /**
   * Method to start the emitter
   * @returns
   */
  private startPortraitShowerEmitter(): void {
    this.emitterPortrait = ingenuity.currentGame.particles.getEmitterById("winCoinEmitterPortrait");
    this.emitterPortrait.autoUpdate = true;
    this.emitterPortrait.emit = true;
  }

  private onSumpBigWin(): void {
    this.hideBigWinDelay = 3000;
    this.desabledStageClick();
    this.stopBigWinAndTicker();
    this.showLastWinBanner();
  }

  // function to stop big win tickup
  protected stopBigWinAndTicker(): void {
    this.bigWinMeter.stopTick(false, true, true);
    this.bigWinMeter.stopTick(false, true, true);
    this.bigWinMeter.stopTick(false, true, true);
    this.bigWinMeter.stopTick(false, true, true);
    this.bigWinMeter.stopTick(false, true, true);
    this.bigWinMeter.setCurrencyFormattedValue(String(this.currentWinAmountTickUp));
    this.bigWinPresentationComplete();
  }

  private showLastWinBanner(): void {
    this.bgLoopSpine.onComplete.dispose();
    this.bigWinBackground.onComplete.dispose();
    if (this.tickupAmountLevel === 1) {
      this.bgLoopSpine.playAnim(spineConstants.BIGWIN_LOOP_ANIM, false);
      this.bigWinBackground.playAnim(spineConstants.BIGWIN_BACKGROUND_LOOP_ANIM, false);
    } else if (this.tickupAmountLevel === 2) {
      this.bgLoopSpine.playAnim(spineConstants.SUPERWIN_LOOP_ANIM, false);
      this.bigWinBackground.playAnim(spineConstants.SUPERWIN_BACKGROUND_LOOP_ANIM, false);
    } else if (this.tickupAmountLevel === 3) {
      this.bgLoopSpine.playAnim(spineConstants.EPICWIN_LOOP_ANIM, false);
      this.bigWinBackground.playAnim(spineConstants.EPICWIN_BACKGROUND_LOOP_ANIM, false);
    } else {
      this.bgLoopSpine.playAnim(spineConstants.CRAZYWIN_LOOP_ANIM, false);
      this.bigWinBackground.playAnim(spineConstants.CRAZYWIN_BACKGROUND_LOOP_ANIM, false);
    }
  }

  /**
   * Add to show big win meter with zoom in effect
   */
  protected showBigWinMeterWithZoomIn(): void {
    this.bigWinMeterContainer.visible = true;
    this.bigWinMeterContainer.scale.set(0, 0);
    this.bigWinMeterContainer.alpha = 1;
    this.bigWinMeter.visible = false;
    this.bigWinMeter.setValue(0);
    this.startBigWinState();
    const bigWinMeterZoomInTween = ingenuity.currentGame.add
      .tween(this.bigWinMeterContainer.scale)
      .to({ x: 1, y: 1 }, 800, Linear.None, true, 0, 0, false);
    bigWinMeterZoomInTween.onComplete.addOnce(() => {
      bigWinMeterZoomInTween.stop();
      ingenuity.currentGame.tweens.remove(bigWinMeterZoomInTween);
      this.showBigWinMeterBasedOnState();
      this.enableStageClick();
      this.startBigWinBasedOnState();
    }, this);
  }

  /** overrrided to reset big spine */
  protected resetElements(): void {
        ingenuity.configData.showLogoBaseGameScreen = true;

    this.hideBigWinDelay = 700;
    if (this.emitter) {
      this.emitter.emit = false;
      this.emitter.autoUpdate = false;
      this.emitter.destroy();
    }
    if (this.emitterPortrait) {
      this.emitterPortrait.emit = false;
      this.emitterPortrait.autoUpdate = false;
      this.emitterPortrait.destroy();
    }
    this.bigWinMeter.setValue(0);
    this.bigWinMeter.onTickupComplete.dispose();
    this.bigWinMeterContainer.scale.set(1, 1);
    this.bigWinMainContainer.alpha = 1;
    this.bigWinBackground.visible = false;
    this.bgLoopSpine.visible = false;
    if (!ingenuity.deviceEnv.isDesktop) {
      this.bgLoopPortraitSpine.visible = false;
      this.bigWinBackgroundPortrait.visible = false;
    }
  }
}
